import MonthlyInfluence from '../pages/MonthlyInfluence/pages/index/reducers'

export default {
  MonthlyInfluence,
}
